var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageCropCircleMask = function SvgImageCropCircleMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image-crop-circle-mask_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 335 335",
    style: {
      enableBackground: "new 0 0 335 335"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".image-crop-circle-mask_svg__st0{clip-path:url(#image-crop-circle-mask_svg__SVGID_00000004509440158881290010000005594404550373081502_)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "image-crop-circle-mask_svg__SVGID_1_",
    d: "M0 0h335v335H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "image-crop-circle-mask_svg__SVGID_00000054232195262426717070000008293697630178483103_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-crop-circle-mask_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#image-crop-circle-mask_svg__SVGID_00000054232195262426717070000008293697630178483103_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.5 0H0v335h335V0H167.5zm0 0C260 0 335 75 335 167.5S260 335 167.5 335 0 260 0 167.5 75 0 167.5 0z",
    style: {
      opacity: 0.6,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#061b09",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 167.5,
    r: 166.5,
    style: {
      fill: "none",
      stroke: "#e7ece9",
      strokeWidth: 2
    }
  })));
};
export default SvgImageCropCircleMask;